// The old && was inside includes(), so it searched the pathname for a boolean.
export const leaveLoanDetailsOnAccountSwitch = (pathname, isABorrower) =>
  String(pathname || "").includes("/loan-details") && !isABorrower;
